import { format, fromUnixTime } from 'date-fns';

export const formatUnixTimestamp = (timestamp: number) => {
  if (!timestamp) return '';
  const date = fromUnixTime(timestamp);
  return format(date, 'EEEE, MMM dd • h:mm aaa');
};
